export default __webpack_public_path__ + "static/media/user-05.e3f603db.jpg";